module.exports = __webpack_public_path__ + "img/shayahmad.1ed9dbce.jpg";